module.exports = __webpack_public_path__ + "static/media/mbis_img_2.493a0121.png";